/*
 *
 * DirectionsPage Transaction constants
 *
 */

export const ITEM_NAVIGATION = 'ItemNavigation';
export const ITEM_RESPONSE = 'ItemResponding';
export const TEST_PAUSED = 'TestPaused';
export const TEST_RESUMED = 'TestResumed';
